import React from "react";

const PaginationContext = React.createContext({
  manager: null,
  setPage: () => {},
});

export default PaginationContext;
